import styled from "styled-components";

export const InfoTr = styled.tr`
  
`;


// WEBPACK FOOTER //
// ./src/components/info-tr/info-tr.component.js